export default "__VITE_ASSET__ff10f64a__"